var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"isotope-challenge-type--check-sync-result"},[_c('isotope-slide',{staticClass:"check-sync-result"},[_c('sync-failure',{attrs:{"buttonText":"Sync.SyncError.Button.Back","url":_vm.baseUrl}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }